module.exports = __webpack_public_path__ + "img/linea_tiempo.7ce8c20b.webp";